import { Link } from 'react-router-dom';
import { SpecStrip } from '../commerce/SpecStrip.jsx';
import { PriceTag } from '../commerce/PriceTag.jsx';
import { Rating } from '../commerce/Rating.jsx';
import { Section, SectionHeading } from '../layout/Section.jsx';
import { imageProps, lqipStyle } from '../../lib/format.js';

/**
 * Three sport products side by side, each with the same three figures, so the
 * difference between them is what the eye lands on. It needs at least two to
 * be a comparison at all, and steps aside below that.
 */
export const SportCompare = ({ products }) => {
  if (!products || products.length < 2) return null;

  return (
    <Section className="border-t border-mist">
      <SectionHeading
        eyebrow="Compare"
        title="Three that do different jobs"
        description="The same three figures on each, so the difference is the thing you read rather than the marketing."
        action={{ label: 'All sport', to: '/shop?world=sport' }}
      />

      <div className="grid gap-4 md:grid-cols-3">
        {products.slice(0, 3).map((product) => (
          <Link
            key={product._id}
            to={`/product/${product.slug}`}
            className="group flex flex-col border border-mist bg-surface p-4 transition-colors hover:border-brand focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand"
          >
            <span className="block aspect-4/3 overflow-hidden bg-cream" style={lqipStyle(product.images?.[0])}>
              {product.images?.[0] && (
                <img
                  {...imageProps(product.images[0], { sizes: '(min-width: 768px) 30vw, 100vw' })}
                  alt={product.images[0].alt || product.title}
                  className="size-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              )}
            </span>
            <SpecStrip items={product.specStrip} className="mt-4 justify-center text-center" />
            <h3 className="mt-2 text-center text-sm font-medium text-ink group-hover:text-brand">{product.title}</h3>
            <div className="mt-auto flex flex-col items-center gap-2 pt-3">
              <PriceTag
                price={product.type === 'variable' ? product.priceRange?.min : product.price}
                priceRange={product.priceRange}
                isVariable={product.type === 'variable'}
              />
              {product.ratingCount > 0 && <Rating value={product.ratingAvg} count={product.ratingCount} />}
            </div>
          </Link>
        ))}
      </div>
    </Section>
  );
};

export default SportCompare;
